module.exports = __webpack_public_path__ + "static/img/80016D_2_3_R_20191211_LC.da561e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/80016D_2_3_R_20191211_LC.png
// module id = KfkV
// module chunks = 0